var map = {
	"./sound_click.wav": [
		102,
		3
	],
	"./sound_cover.wav": [
		103,
		4
	],
	"./sound_pair.wav": [
		104,
		5
	],
	"./sound_pairNumber.wav": [
		105,
		6
	],
	"./sound_spawn_001.wav": [
		106,
		7
	],
	"./sound_spawn_002.wav": [
		107,
		8
	],
	"./sound_spawn_003.wav": [
		108,
		9
	],
	"./sound_transition.wav": [
		45
	],
	"./sound_uncover.wav": [
		109,
		10
	],
	"./sound_win.wav": [
		110,
		11
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 68;
module.exports = webpackAsyncContext;